var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-chart-widget"},[_c('b-card',{attrs:{"header":_vm.title}},[_c('PieGraph',{attrs:{"height":200,"chart-data":_vm.chartData.chartData,"options":_vm.chartData.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }